export default [
  {
    path: '/myself/hotAd',
    name: 'hotAd',
    meta: {
      title: '热区广告位'
    },
    component(resolve) {
      require(['COMPONENTS/myself/hotAd/main.vue'], resolve)
    }
  },
  {
    path: '/myself/hotAdEdit',
    name: 'hotAdEdit',
    meta: {
      title: '热区广告位编辑'
    },
    component(resolve) {
      require(['COMPONENTS/myself/hotAd/edit.vue'], resolve)
    }
  },
]